<template>
  <div>
    <PageHeader page-name="Удаленые предложения">
      <template>
        <FilterPanel>
          <FilterOffersTrash @filter="doFilter" />
        </FilterPanel>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" :data="offersTrash.data" />
      <el-pagination
        v-if="meta"
        background
        :current-page="filterObject.page"
        hide-on-single-page
        layout="prev, pager, next"
        :page-size="meta.per_page"
        :total="meta.total"
        @current-change="changePage"
      />
    </MainPanel>
  </div>
</template>

<script>
import List from '@/components/offers-trash/List'
import {mapActions} from 'vuex';
import MainPanel from '@/components/common/MainPanel'
import FilterPanel from '@/components/common/FilterPanel'
import FilterOffersTrash from '@/components/offers-trash/FilterOffersTrash'
import PageHeader from '@/components/common/PageHeader';


export default {
  name: 'ListPage',
  components: {FilterOffersTrash, FilterPanel, List, MainPanel, PageHeader},
  data(){
    return{
      loading:false,
      filterObject: {
        page: 1,
      },
      offersTrash:[],
    }
  },

  computed:{
    meta() {
      return this.offersTrash?.meta
    },

  },

  async created() {
    this.offersTrash = await this.fetchOffersTrash(this.filterObject)
  },
  methods:{
    ...mapActions('offersTrash', [
      'fetchOffersTrash',
    ]),

    async getOffersTrash() {
      this.loading = true
      this.offersTrash = await this.fetchOffersTrash(this.filterObject)
      this.loading = false
    },
    changePage(page) {
      this.filterObject.page = page
      this.getOffersTrash()
    },
    doFilter(filters) {
      this.filterObject = {...this.filterObject, ...filters}
      this.filterObject.page = 1
      this.getOffersTrash()
    },

  },
}


</script>

<style scoped>

</style>
